import React from 'react';
import { GetUserIdentifiersQueryResult } from '../../Admin/shared/graphql/queries/getUserIdentifiers.generated';

/**
 * Implement an accurate TS type for the user object in AuthContext
 *
 * https://springhealth.atlassian.net/browse/CORE-2649
 */
export type AdminUser = NonNullable<GetUserIdentifiersQueryResult['data']>['user'];

export type AuthContextType = {
  user?: { mfa_enabled: boolean; scopes: string[] } & AdminUser;
  loading?: boolean;
  // Whether this session signs in with Auth0 (auth0_admin_portal_login_2026_temp) rather than Diglet
  isAuth0Login?: boolean;
  onSignInInitializeUser: (user: AdminUser) => void;
  onLogout: () => void;
};

export const AuthContext = React.createContext<AuthContextType>({
  onSignInInitializeUser: () => {},
  onLogout: () => {},
});
